const uiUrls = {}

const apiUrls = {
  list() {
    return `/api/app_configs`
  },

  show(configId: string) {
    return `/api/app_configs/${configId}`
  },
}

export const config = {
  ui: {
    urls: uiUrls,
  },
  api: {
    urls: apiUrls,
  },
}
